import './_product-customizer-info.scss';

export default () => {};
